import { AppProps } from './entry'
import { HomeProps } from './pages/Home/Home'

export const onlyNumbers = (value = '') => value.replace(/[^\d]/g, '')

export const parsedItemsNewMyAccount = (value: AppProps['itemsMyAccount']) => {
  return JSON.parse(
    value as unknown as string
  ) as HomeProps['itemsMyAccount']
}
